// ──────────────────────────────────────────────────────────────
// 날짜 표시 포맷 — 단일 진실 공급원
// 다양한 입력("20260522"/"2026-05-22"/"2026.5.22"/"2026년 5월 22일"/"5월 22일")을
// 일관된 "YYYY.MM.DD"로 정규화. 못 파싱하면 원본 그대로(잘못 가공 안 함 — 신뢰성).
// "단독 N월 N일"은 연도가 없어 기준연도(now) 가정 — 테스트 위해 now 선택 인자 지원.
// (2026-06-18 모듈화 8단계)
// ──────────────────────────────────────────────────────────────
function fD(d, now) {
  if (!d) return '';
  const s = String(d).trim();
  if (!s) return '';
  if (/^\d{8}$/.test(s)) return `${s.substring(0, 4)}.${s.substring(4, 6)}.${s.substring(6, 8)}`;
  const m = s.match(/(\d{4})[-./\s]+(\d{1,2})[-./\s]+(\d{1,2})/);
  if (m) return `${m[1]}.${String(m[2]).padStart(2, '0')}.${String(m[3]).padStart(2, '0')}`;
  const k = s.match(/(\d{4})년\s*(\d{1,2})월\s*(\d{1,2})일/);
  if (k) return `${k[1]}.${String(k[2]).padStart(2, '0')}.${String(k[3]).padStart(2, '0')}`;
  const ym = s.match(/(\d{4})년\s*(\d{1,2})월/);
  if (ym) return `${ym[1]}.${String(ym[2]).padStart(2, '0')}`;
  const md = s.match(/^(\d{1,2})월\s*(\d{1,2})일/);
  if (md) { const y = (now || new Date()).getFullYear(); return `${y}.${String(md[1]).padStart(2, '0')}.${String(md[2]).padStart(2, '0')}`; }
  return s;
}

module.exports = { fD };
